import React from 'react';
import JSZip from 'jszip';


export function DownloadFile(fileData, fileName) {
    const fileType = determineFileType(fileName);
    if (fileType)
        downloadKnownFile(fileData, fileType);
    else 
        downloadUnKnownFile(fileData, fileName);
      
    function determineFileType(fileName) {
        const fileExtension = fileName.split('.').pop().toLowerCase();
        
        if (fileExtension === 'xlsx' || fileExtension === 'xls') {
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        } else if (fileExtension === 'pdf') {
            return 'application/pdf';
        } else if (fileExtension === 'docx' || fileExtension === 'doc') {
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        }
        // ... diğer dosya türlerini buraya ekleyebilirsiniz
        
        return null; // Bilinmeyen dosya türü
    }

    function downloadKnownFile(fileData, fileType){
        const byteCharacters = atob(fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
    
        var blob = new Blob([byteArray], { type: fileType });
        var url = URL.createObjectURL(blob);
        window.open(url);
    }

    function downloadUnKnownFile(fileData, fileName){
        const byteCharacters = atob(fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray]);
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function DownloadZipFile(files) {
    const zip = new JSZip();

    files.forEach((file) => {
        let { fileData, fileName, type } = file;
    
        let suffix = "";
        switch (type) {
            case "signed":
                suffix = "_imzali_dokuman";
                break;
            case "approval":
                suffix = "_surec_dokumani";
                break;
            case "additional":
                suffix = "_ek_dokuman";
                break;
        }
    
        let fileExtension = fileName.substring(fileName.lastIndexOf("."));
        if (type === "signed" && fileExtension !== ".pdf") {
            fileExtension = ".cms";
        }
        const newFileName = fileName.replace(/\.[^/.]+$/, "") + suffix + fileExtension; // Yeni dosya adı

        const byteCharacters = atob(fileData);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        zip.file(newFileName, byteArray); // ZIP içine dosya ekleme
    });

    // ZIP dosyasını oluştur ve indir
    zip.generateAsync({ type: "blob" }).then((content) => {
        const url = URL.createObjectURL(content);
        const link = document.createElement("a");
        link.href = url;
        link.download = "EasySign.zip";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}